module.exports = __webpack_public_path__ + "static/media/downtown_childrens_mural_2003.764e8fb8.webp";